import React from 'react';
import { Trans } from 'react-i18next';

import { toasterInstance } from '../../services';

import {
  doCreateCloudClient,
  doCheckCloudClient,
} from '../../actions';

export const createCloudClient = async (formData, setReload, setIsError, setMsg) => {
  setReload(true);

  try {
    const res = await doCreateCloudClient(formData);

    if (res.status && res.status === 201) {
      setIsError(false);
      setMsg(<Trans>{res.message}</Trans>);
    } else {
      setIsError(true);
      if (res.data) {
        if (typeof (res.data.response.errors) === 'string') {
          setMsg(<Trans>{res.data.response.errors}</Trans>);
          toasterInstance(<Trans>{res.data.response.errors}</Trans>, 4, 'failedUser');
        } else {
          setMsg(<Trans>{res.data.response.errors[0].msg}</Trans>);
          res.data.response.errors.forEach((data) => {
            toasterInstance(<Trans>{data.msg}</Trans>, 4, 'failedUser');
          });
        }
      } else if (res?.response) {
        setMsg(<Trans>{res.response.errors[0].msg}</Trans>);
        res.response.errors.forEach((data) => {
          toasterInstance(<Trans>{ data.msg}</Trans>, 4, 'failedUser');
        });
      }
      setReload(false);
    }
  } catch (e) {
    setIsError(true);
    setReload(false);
    setMsg(<Trans>TOASTER.CLIENT_C_FAIL</Trans>);
    // toasterInstance(<Trans>TOASTER.CLIENT_C_FAIL</Trans>, 4, 'failedClient');
  }
};

export const checkCloudClient = async (formData, setReload, setIsError, setMsg) => {
  setReload(true);
  setIsError(true);
  try {
    const res = await doCheckCloudClient(formData);

    if (res.status && res.status === 201) {
      setIsError(false);
      return true;
      // setMsg(<Trans>{"API." + res.message}</Trans>)
      // toasterInstance(<Trans>{"API." + res.message}</Trans>, 2, 'successUser');
    }
    setIsError(true);
    if (res.data) {
      if (typeof (res.data.response.errors) === 'string') {
        setMsg(<Trans>{res.data.response.errors}</Trans>);
        toasterInstance(<Trans>{res.data.response.errors}</Trans>, 4, 'failedUser');
      } else {
        setMsg(<Trans>{res.data.response.errors[0].msg}</Trans>);
        res.data.response.errors.forEach((data) => {
          toasterInstance(<Trans>{data.msg}</Trans>, 4, 'failedUser');
        });
      }
      return false;
    } if (res?.response) {
      setMsg(<Trans>{res.response.errors[0].msg}</Trans>);
      res.response.errors.forEach((data) => {
        toasterInstance(<Trans>{data.msg}</Trans>, 4, 'failedUser');
      });
      return false;
    }
    setReload(false);
  } catch (e) {
    setIsError(true);
    setReload(false);
    setMsg(<Trans>TOASTER.PROJECT_C_FAILED</Trans>);
    toasterInstance(<Trans>TOASTER.PROJECT_C_FAILED</Trans>, 4, 'failedClient');
    return false;
  }
};
